// import axios from "axios";

// export default axios.create({
//     baseURL: 'https://myphotobomb.com/'
// });

const base_url = 'https://myphotobomb.com/admin/';

export default base_url;